import type { FinIntellectModel, UserRetailAccount } from './types';

// Display labels for retired sentinel values so historical records (e.g. past
// rebalancing actions) still render correctly. Live model keys get their label
// from FinIntellect (GET /models/available); this map is only a fallback.
export const FININTELLECT_MODEL_LABELS: Record<string, string> = {
  legacy: 'FinIntellect (Legacy)',
  new: 'FinIntellect (New)',
};

// Sentinel used in the dropdown to mean "no explicit model -> use the
// FinIntellect default served model".
export const FININTELLECT_DEFAULT_MODEL_VALUE = '__default__';
export const FININTELLECT_DEFAULT_MODEL_LABEL = 'Default (FinIntellect)';

export const finintellectModelId = (
  model?: FinIntellectModel | null,
): FinIntellectModel | null => model ?? null;

// Human label for a model value. Prefers an explicit label map (from the live
// available-models list, merged in by the caller), then the retired-sentinel
// map, then the raw key. null/empty (= "follow FinIntellect's default") renders
// `defaultLabel` — pass the served default's label when it is known so the UI
// names the model actually in use instead of the generic sentinel.
export const finintellectModelLabel = (
  model?: FinIntellectModel | null,
  labelByKey?: Record<string, string>,
  defaultLabel: string = FININTELLECT_DEFAULT_MODEL_LABEL,
): string => {
  if (!model) return defaultLabel;
  return (
    labelByKey?.[model] ?? FININTELLECT_MODEL_LABELS[model] ?? model
  );
};

export const portfolioStrategyLabel = (
  account: UserRetailAccount,
  labelByKey?: Record<string, string>,
  defaultLabel?: string,
): string => {
  const modelStr = finintellectModelLabel(account.finintellectModel, labelByKey, defaultLabel);
  const sfStr = account.signal_forge_enabled ? 'SignalForge ON' : 'SignalForge OFF';
  return `${modelStr} · ${sfStr}`;
};
